<template>
  <div
    class="loading grey--text text--darken-1 px-5">
    <v-progress-circular
      indeterminate
      color="primary"
      class="mx-auto mt-5 mb-3"></v-progress-circular>
      {{ $t(statusKey) }}
  </div>
</template>

<script>
export default {
  name: 'loading-status',
  props: {
    statusKey: {
      type: String
    }
  }
}
</script>

<style scoped>
.loading {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  text-align: center;
}
</style>
